import { UrlMatchResult, UrlSegment } from "@angular/router";
import { readStoredToken } from "../../services/auth.service";

/** Slugs de las páginas de producto de la landing 2026. */
export const LANDING_PRODUCT_SLUGS = ["alimentador-nas", "waterwise", "plataforma-web"];

/**
 * Decide si la URL pertenece a la landing 2026 sin cargar el módulo.
 * - `/` solo para visitantes sin sesión (con sesión sigue el flujo del panel).
 * - `/productos/<slug>` para los productos conocidos.
 * No consume segmentos: las rutas hijas del módulo resuelven la URL completa.
 * @param segments Segmentos de la URL.
 * @returns Resultado vacío si coincide o `null` para dejar pasar a las siguientes rutas.
 */
export function landingMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const isHome = segments.length === 0 && !readStoredToken();
  const isProduct =
    segments.length === 2 &&
    segments[0].path === "productos" &&
    LANDING_PRODUCT_SLUGS.indexOf(segments[1].path) !== -1;

  return isHome || isProduct ? { consumed: [] } : null;
}
